import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { ComparisonCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';
import { ComparisonTooltipComponentService } from './components/comparison-tooltip';

export function comparisonTooltipFactory(comparisonTooltipService: ComparisonTooltipComponentService): () => void {
  return () => comparisonTooltipService.init();
}

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        comparison: {
          module: () => import('./components/comparison/comparison.module').then((m) => m.ComparisonModule),
          cmsComponents: [ComparisonCmsComponents.RosaCMSComparisonComponent],
        },
        comparisonMain: {
          module: () =>
            import('./components/comparison-main/comparison-main.module').then((m) => m.ComparisonMainModule),
          cmsComponents: [ComparisonCmsComponents.RosaCMSComparisonMainComponent],
        },
      },
    }),
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = comparisonTooltipFactory(inject(ComparisonTooltipComponentService));

      return initializerFn();
    }),
  ],
})
export class ComparisonUiModule {}
